import Component from './platform-button.component';
import * as Constants from './platform-selection-button.constants';

export { Component, Constants };

export default Component;
